import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { gbp } from "../lib/api";

export const GatedPrice = ({ deal, size = "md" }) => {
  const { isMember } = useAuth();
  const navigate = useNavigate();
  const priceCls = size === "lg" ? "text-4xl sm:text-5xl" : "text-2xl";

  return (
    <div>
      <div className="flex items-end gap-3 flex-wrap">
        <span data-testid="deal-price" className={`font-display ${priceCls} text-[#FFCC00] ${isMember ? "" : "price-locked"}`}>
          {isMember ? gbp(deal.member_price) : "£888.00"}
        </span>
        <span className="text-white/40 text-xs line-through">RRP {gbp(deal.rrp_total)}</span>
        <span className={`bg-[#FF3B30] text-white text-xs font-bold px-2 py-0.5 ${isMember ? "" : "price-locked"}`}>
          {isMember ? `-${deal.saving_pct}%` : "-88%"}
        </span>
      </div>
      {!isMember && (
        <button
          type="button"
          data-testid="unlock-price-link"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate("/join"); }}
          className="inline-block mt-2 text-[#FFCC00] text-xs uppercase tracking-widest border-b border-[#FFCC00] hover:text-white hover:border-white"
        >
          Join free to unlock member price →
        </button>
      )}
    </div>
  );
};
